import { styled } from '@mui/material'
import { BigNumber } from 'ethers'
import { memo } from 'react'
import { useTranslation } from 'react-i18next'
import { useCurrencyBalance } from 'store/account/hooks'
import { useDepositAmount, useDepositToken } from 'store/deposit/hook'
import { Space8 } from 'styles'
import { parseWeiToEther, toFixed } from 'utils/number'
import { HeaderTip, FromTip } from './styles'
import { StyledControlInputLarge } from '../../styles/Control'

export const ReceiveWrap = styled(StyledControlInputLarge)`
  justify-content: space-between;
  font-size: 16px;
  color: ${(props) => props.theme.color.text70};
  border-radius: 6px;

  b {
    font-weight: 600;
  }
`

export const DepositReceive = memo(() => {
  const { t } = useTranslation()
  const amount = useDepositAmount()
  const selectedToken = useDepositToken()
  const l2Balance = useCurrencyBalance(selectedToken?.name!)?.available ?? ''

  const formatBalance = (balance: string | BigNumber): string => {
    let amount: string = parseWeiToEther(balance, 2)
    return amount
  }

  return (
    <>
      <HeaderTip>
        <FromTip>
          <strong>{t('deposit-to')}</strong> {t('deposit-zkex-wallet')}
        </FromTip>
        <div>
          {t('deposit-balance')}: {formatBalance(l2Balance)}{' '}
          {selectedToken?.name}
        </div>
      </HeaderTip>
      <Space8 />
      <ReceiveWrap>
        <span>{t('deposit-receive')}</span>
        <b>
          {toFixed(amount || '0')} {selectedToken?.name}
        </b>
      </ReceiveWrap>
    </>
  )
})
